import {
    AppBar, Toolbar, Typography,
} from '@material-ui/core'
import { signOut } from 'aws-amplify/auth'
import { Hub } from 'aws-amplify/utils'
import * as React from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { containerStyles } from '../../styles/ContainerStyles'
import { textStyles } from '../../styles/TextStyles'
import { invoke } from '../../utils/helper'
import { UserDto } from '../../utils/types'
import { ScrollLink } from '../atoms/NavLink'
import { LogoutModal } from './LogoutModal'
import { ScrollToColor } from './ScrollToColor'

interface Props {
    signedIn: boolean
    user: UserDto | undefined
}

export const Navbar : React.FC<Props> = ({ user, signedIn }) => {

    const [logout, setLogout] = React.useState(false)
    const [loggingOut, setLoggingOut] = React.useState(false)
    const history = useHistory()

    const styles = containerStyles()
    const tStyles = textStyles()
    const path = useLocation()

    const hide = path.pathname === '/spil' || path.pathname.startsWith('/spil/')

    const handleLogout = async () => {
        await invoke(async () => {
            await signOut()

            Hub.dispatch('auth', { event: 'signOut' })
            setLoggingOut(false)

            window.location.pathname = '/'
        }, {
            operation: 'logging out',
            stateFunc: setLoggingOut
        })
    }

    if (hide) {
        return (
            <div/>
        )
    }

    return (
        <ScrollToColor>
            <AppBar position="fixed">
                <Toolbar className={styles.navWrap}>
                    <div>
                        <Typography
                            className={tStyles.logo}
                            onClick={() => history.push('/')}>Garderhøj
                        </Typography>
                    </div>
                    {!signedIn
                        && (
                            <div className={styles.navBtnWrapper}>
                                <ScrollLink>
                                    <Typography
                                        onClick={() => history.push('/video')}
                                        variant="h6"
                                        noWrap>
                                        Instruktionsvideo
                                    </Typography>
                                </ScrollLink>
                                <ScrollLink>
                                    <Typography
                                        onClick={() => history.push('/oprette-bruger')}
                                        variant="h6"
                                        noWrap>
                                        Opret Bruger
                                    </Typography>
                                </ScrollLink>
                                <ScrollLink>
                                    <Typography onClick={() => history.push('/log-ind')} variant="h6" noWrap>
                                        Log Ind
                                    </Typography>
                                </ScrollLink>
                            </div>
                        )}
                    {user
                        && (
                            <div style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                width: '100%',
                            }}>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between'
                                }}>
                                    <Typography
                                        className={styles.link}
                                        onClick={() => history.push('/escape-rooms')}>
                                        Se Escape Rooms
                                    </Typography>
                                    <Typography
                                        className={styles.link}
                                        onClick={() => history.push('/opgaver')}>
                                        Se Opgaver
                                    </Typography>
                                    <Typography
                                        className={styles.link}
                                        onClick={() => history.push('/video')}>
                                        Instruktionsvideo
                                    </Typography>
                                    <Typography
                                        className={styles.link}
                                        onClick={() => history.push('/profil')}>
                                        Min Profil
                                    </Typography>
                                </div>

                                <ScrollLink>
                                    <Typography
                                        style={{ display: 'flex', justifyContent: 'flex-end' }}
                                        onClick={() => setLogout(true)}
                                        variant="h6"
                                        noWrap>
                                        Log ud
                                    </Typography>
                                </ScrollLink>
                            </div>
                        )}

                    <LogoutModal
                        disableAccept={loggingOut}
                        onConfirmAction={handleLogout}
                        onClose={() => setLogout(true)}
                        onCancelAction={() => setLogout(false)}
                        isOpen={logout}
                        headerText="Er du sikker på at du vil logge ud?"
                        confirmActionButtonText="Ja, helt sikker"
                        cancelActionButtonText="Nej"/>
                </Toolbar>
            </AppBar>
        </ScrollToColor>
    )
}
